<template>
  <div>
    <aw-checkout-take-over-data-form
      v-if="isCreateFormVisible"
      :is-guest-checkout="isGuestCheckout"
      :department-stores="departmentStores"
      :selected-delivery-method="selectedDeliveryMethod"
      @take-over-data-saved="onTakeOverSaved"
    />
  </div>
</template>

<script setup>
  import { computed, inject, watch } from 'vue';
  import { DELIVERY_METHODS } from '~~/shop/awPlugins/app-config.js';
  import { useDeliveryStore } from '~~/shop/stores/delivery.js';
  import { useUserStore } from '~~/common/stores/user.js';
  import AwCheckoutTakeOverDataForm from '~~/shop/components/Page/Checkout/DeliveryData/AwCheckoutTakeOverDataForm.vue';

  const props = defineProps({
    selectedDeliveryMethod: {
      type: Object,
      default: null,
    },
    deliveryData: {
      type: Object,
      default: null,
    },
    isCreateFormVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    isListFormVisible: {
      type: Boolean,
      required: true,
      default: false,
    },
    isModalMode: {
      type: Boolean,
      required: true,
      default: false,
    },
  });

  const updateDeliveryData = inject('updateDeliveryData');

  const emits = defineEmits([
    'close-modal',
    'update:is-create-form-visible',
    'update:is-list-form-visible',
  ]);

  const isGuestCheckout = computed(() => !useUserStore().isEcomUser);

  const departmentStores = computed(() => useDeliveryStore().departmentStores);

  watch(
    () => props.deliveryData?.deliveryMethod,
    (newValue) => {
      if (newValue !== DELIVERY_METHODS.DELIVERY_CLICK_AND_COLLECT && !props.isModalMode) {
        emits('update:is-create-form-visible', true);
        emits('update:is-list-form-visible', false);
      }
    },
    {
      immediate: true,
    },
  );

  function onEditClicked () {
    updateDeliveryData(null);
    emits('update:is-create-form-visible', true);
    emits('update:is-list-form-visible', false);
  }

  function onTakeOverSaved () {
    emits('update:is-create-form-visible', false);
    emits('update:is-list-form-visible', false);
    emits('close-modal', { afterSave: true });
  }

  defineExpose({
    onEditClicked,
  });
</script>
